import { useStyle } from "@/classify"
import useFieldState from "@/common/hooks/hook-wrappers/useInformedFieldStateWrapper"
import { Message } from "@/components/Field"
import { Checkbox as InformedCheckbox, useFieldApi } from "informed"
import { Fragment, useEffect } from "react"
import { CheckSquare, Square } from "react-feather"
import defaultClasses from "./checkbox.module.css"

let defaultCheckedIcon = <CheckSquare />
let defaultUncheckedIcon = <Square />

function UnCheckedSvg() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='0.5' y='0.5' width='19' height='19' stroke='#5E5047' />
    </svg>
  )
}

function CheckedSvg() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='0.5' y='0.5' width='19' height='19' stroke='#5E5047' />
      <rect x='2' y='2' width='16' height='16' fill='#80583F' />
    </svg>
  )
}

const Checkbox = (props) => {
  const {
    ariaLabel,
    classes: propClasses,
    field,
    fieldValue,
    id,
    label,
    message,
    filter,
    checkedIcon,
    uncheckedIcon,
    ...rest
  } = props
  const fieldApi = useFieldApi(field)
  const fieldState = useFieldState(field)
  const classes = useStyle(defaultClasses, propClasses)

  if (filter) {
    defaultCheckedIcon = <CheckedSvg />
    defaultUncheckedIcon = <UnCheckedSvg />
  }

  if (checkedIcon !== undefined) {
    defaultCheckedIcon = checkedIcon
  }

  if (uncheckedIcon !== undefined) {
    defaultUncheckedIcon = uncheckedIcon
  }

  const icon = fieldState.value ? defaultCheckedIcon : defaultUncheckedIcon

  useEffect(() => {
    if (fieldValue != null && fieldValue !== fieldState.value) {
      fieldApi.setValue(fieldValue)
    }
  }, [fieldApi, fieldState.value, fieldValue])

  return (
    <Fragment>
      <label
        data-cy='Checkbox-label'
        aria-label={ariaLabel}
        className={classes.root}
        htmlFor={id}
      >
        <InformedCheckbox
          {...rest}
          className={[classes.input, classes.inputForLabel].join(" ")}
          field={field}
          id={id}
        />
        <span className={classes.icon}>{icon}</span>
        <span className={classes.label}>{label}</span>
      </label>
      <Message fieldState={fieldState}>{message}</Message>
    </Fragment>
  )
}

export default Checkbox
